import React from "react"
import { EmblaOptionsType } from "embla-carousel"
import { PrevButton, NextButton, usePrevNextButtons } from "./arrow-button"
import useEmblaCarousel from "embla-carousel-react"
import Image from "next/image"
import Autoplay from "embla-carousel-autoplay"
import Link from "next/link"
import { ImageItem } from "../types"

type Props = {
  slides: ImageItem[]
  options?: EmblaOptionsType
}

const Carousel = (props: Props) => {
  const S3_IMAGE_BASE_URL = process.env.NEXT_PUBLIC_S3_IMAGE_BASE_URL
  const { slides, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    Autoplay({ playOnInit: true, delay: 3000 }),
  ])

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi)

  return (
    <section className="embla w-full">
      <div
        className="embla__viewport relative rounded-xl shadow-md overflow-hidden"
        ref={emblaRef}
      >
        <div className="embla__container z-10">
          {slides?.map((item, index) => (
            <Link
              href={item.product_category_handle === 'store' ? '/store' : `/categories/${item.product_category_handle}`}
              className="embla__slide"
              key={index}
            >
              <div className="w-full h-full">
                <div className="aspect-[1970/920] xl:h-[360px] lg:h-[320px] md:h-[350px] sm:h-[300px]">
                  <Image
                    src={`${S3_IMAGE_BASE_URL}${item.image}`}
                    fill
                    alt={item.name}
                    objectFit="cover"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
        <PrevButton
          onClick={onPrevButtonClick}
          disabled={prevBtnDisabled}
          className="absolute left-0 top-1/2 flex h-20 w-20 -translate-y-1/2 items-center justify-center text-slate-900"
        />
        <NextButton
          onClick={onNextButtonClick}
          disabled={nextBtnDisabled}
          className="absolute right-0 top-1/2 flex h-20 w-20 -translate-y-1/2 items-center justify-center text-slate-900"
        />
      </div>

      {/* <div className="embla__controls">
        

        <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={"embla__dot".concat(
                index === selectedIndex ? " embla__dot--selected" : ""
              )}
            />
          ))}
        </div>
      </div> */}
    </section>
  )
}

export default Carousel
